export const default_constraints = {
	limit_votes: false,				// True to limit the votes to required number on the ballot
	no_freesolo: false,         	// True to limit the selection of names to the list
	no_duplicates: false,       	// Do not allow duplicate names
	allow_warning: true,			// warn if ballot is invalid
	enable_warnings_default: true,	// enable checks switch defaults
	autocomplete: true,				// autocomplete
	enable_check: true,				// enable checking in election Normal
	sort_votes: false,				// Sort votes alphabetically in ballot display
} as const;